
import {
  DxDataGrid, DxColumn, DxEditing, DxPaging
} from 'devextreme-vue/data-grid';
import { DxToast } from 'devextreme-vue/toast';
import ControlSizeService from '../services/control-size-service';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxToast,
  },
  data() {
    return {      
      dataSourceControlSize: null,
      tamanoControl: {},
      events: [],
      controlSizeService: null,
      isVisible: false,
      message: '',
      type: 'info',
    };
  },
  created() {
    this.controlSizeService = new ControlSizeService();
  },
  mounted() {    
    this.controlSizeService.getTamanoControles().then(data => this.dataSourceControlSize=data);
  },
  methods: {
    logEvent(eventName) {
      this.events.unshift(eventName);
    },
    editControlSize(e) {
			this.controlSizeService.updateTamanoControl(e.data).then(() => {
        this.type = 'success';
        this.message = 'Se ha actualizado el registro';
        this.isVisible = true;        
      });
		},
    deleteControlSize(e) {
			this.controlSizeService.deleteTamanoControl(e.data).then(() => {
        this.type = 'success';
        this.message = 'Se ha eliminado el registro';
        this.isVisible = true;
      });
		},
    createControlSize(e) {
			this.controlSizeService.createTamanoControl(e.data).then(() => {
        this.type = 'success';
        this.message = 'Se ha creado el registro';
        this.isVisible = true;
      });
		},
  },
};
